import ReactDOM from 'react-dom';
import './styles/style.scss';
import './styles/result.scss';
import PostDelivery from './pages/PostDelivery';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Success from './pages/Success';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider, RequireAuth } from './auth/AuthProvider';
import Result from './pages/Result';
import Login from './pages/Login';
import LogoImg from './components/LogoImg';
import SuccessPerfect from './pages/SuccessPerfect';

ReactDOM.render(
  <BrowserRouter>
    <header>
      <LogoImg />
    </header>
    <AuthProvider>
      <Routes>
        <Route path="/p/:custCode" element={<PostDelivery contactBack={false} bett={false} />} />
        <Route path="/c/:custCode" element={<PostDelivery contactBack={true} bett={false} />} />
        <Route path="/bp/:custCode" element={<PostDelivery contactBack={false} bett={true} />} />
        <Route path="/bc/:custCode" element={<PostDelivery contactBack={true} bett={true} />} />
        <Route path="/s/:contactBack&lang=:lang" element={<Success />} />
        <Route path="/sp/lang=:lang" element={<SuccessPerfect />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/result"
          element={
            <RequireAuth>
              <Result />
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
